const Languages = [
    {
        name: 'HTML',
        img: 'SiHtml5'
    }
]

export default Languages;